export default "__VITE_ASSET__e0896c74__"